var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"app",class:{
    'app--window': _vm.URLParams.type !== 'social',
    'app--page': _vm.URLParams.type === 'social',
  }},[_c('div',{staticClass:"app__content"},[_c('v-fade-transition',{attrs:{"origin":"top center"}},[_c('router-view')],1),_c('app-loader'),_c('vue-snotify')],1),_c('v-fade-transition',{attrs:{"origin":"top center"}},[(_vm.URLParams.type === 'social')?_c('div',{staticClass:"app__footer"},[_c('facebook-footer')],1):_vm._e()])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }